export const translations = {
  "es": {
    "Translate this text": "Traduce este texto",
    "Hello {n}!": "Hola {n}!",
  }
}


// WEBPACK FOOTER //
// ./src/translations/translations.js